import { useI18n } from 'vue-i18n'
import type { EnquiryType } from '@/graphql/api'

type EnquiryFormTranslations = {
    [K in EnquiryType]: {
        title: () => string
        submit: () => string
    }
}

export function useEnquiryFormTranslations(): EnquiryFormTranslations {
    const { t } = useI18n()

    return {
        BLOG_POST: {
            title: () => t('enquiry.form.blog_post.title'),
            submit: () => t('enquiry.form.blog_post.submit'),
        },
        ENGAGEMENT_RING: {
            title: () => t('enquiry.form.engagement_ring.title'),
            submit: () => t('enquiry.form.engagement_ring.submit'),
        },
        ENGAGEMENT_RING_BROWSE: {
            title: () => t('enquiry.form.engagement_ring_browse.title'),
            submit: () => t('enquiry.form.engagement_ring_browse.submit'),
        },
        JEWELLERY_PRODUCT_LANDING_GENERIC: {
            title: () =>
                t('enquiry.form.jewellery_product_landing_generic.title'),
            submit: () =>
                t('enquiry.form.jewellery_product_landing_generic.submit'),
        },
        WEDDING_RING: {
            title: () => t('enquiry.form.wedding_ring.title'),
            submit: () => t('enquiry.form.wedding_ring.submit'),
        },
        WEDDING_RING_BESPOKE_LANDING: {
            title: () => t('enquiry.form.wedding_ring_bespoke_landing.title'),
            submit: () => t('enquiry.form.wedding_ring_bespoke_landing.submit'),
        },
        LOCATION_SIGNUP: {
            title: () => t('enquiry.form.location_signup.title'),
            submit: () => t('enquiry.form.location_signup.submit'),
        },
    }
}
